"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiWindows24 = {
    paths: [
        {
            path: 'M22.075817,12.4733514 L22.075817,23.9224865 L9.22875921,21.4342703 L9.22875921,12.4733514 L22.075817,12.4733514 Z M7.98224816,12.4733514 L7.98224816,21.1916757 L0.0142628993,19.6504865 L0.0142628993,12.4733514 L7.98224816,12.4733514 Z M22.075817,0.0718378378 L22.075817,11.5018378 L9.22875921,11.5018378 L9.22875921,2.56021622 L22.075817,0.0718378378 Z M7.98224816,2.80086486 L7.98224816,11.5018378 L0.0142628993,11.5018378 L0.0142628993,4.344 L7.98224816,2.80086486 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Windows',
    width: 23,
    height: 24,
};
var muiWindows = {
    base: muiWindows24,
    lgIcon: muiWindows24,
};
exports.muiWindows = muiWindows;
//# sourceMappingURL=windows.js.map